module.exports = __webpack_public_path__ + "images/stickers/pete-space.ee70c40e8a7906f3adf2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-space.png
// module id = +6mr
// module chunks = 12